import gsap from 'gsap';
import { useEffect, useState } from 'react';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { useReducedMotion } from 'framer-motion';
import useMediaQueries from '@stone/hooks/useMediaQueries';
import cookie from 'react-cookies';
import customEventBus from '@common/scripts/libs/eventBus';
gsap.registerPlugin(ScrollTrigger);
const markers = cookie.load('gsap_markers') === 'sticky-bar';
const useStickybarAnimation = () => {
    var _a;
    // ANCHOR - USE STATE -------------------------------------------------------------------
    const [ref, setRef] = useState(null);
    const [headerHeight, setHeaderHeight] = useState(((_a = document.querySelector('header')) === null || _a === void 0 ? void 0 : _a.offsetHeight) || 0);
    // ANCHOR - USE HOOKS -------------------------------------------------------------------
    const isReduceMotion = useReducedMotion();
    const { isDesktop } = useMediaQueries();
    const negativeMapper = gsap.utils.mapRange(0, 1, 1, 0);
    useEffect(() => {
        customEventBus.on('pdp:details', setScrollTriggers);
        return () => {
            customEventBus.off('pdp:details', setScrollTriggers);
        };
    }, [ref]);
    useEffect(() => {
        setScrollTriggers();
        return resetScrollTriggers;
    }, [isReduceMotion, isDesktop, ref, headerHeight]);
    const onSetHeight = (data) => {
        setHeaderHeight(data.height);
    };
    useEffect(() => {
        if (isDesktop) {
            customEventBus.on('header:setheight', onSetHeight);
            return () => {
                customEventBus.off('header:setheight', onSetHeight);
            };
        }
    }, [isDesktop]);
    const IDS = ['pdp-sticky-in', 'pdp-sticky-out', 'pdp-sticky-mobile', 'pdp-header-in'];
    const resetScrollTriggers = () => {
        IDS === null || IDS === void 0 ? void 0 : IDS.forEach((id) => { var _a; return (_a = ScrollTrigger.getById(id)) === null || _a === void 0 ? void 0 : _a.kill(); });
    };
    //  SECTION - GSAP --------------------------------------------------------------------
    const setScrollTriggers = () => {
        if (ref && !isReduceMotion) {
            const ctas = document.querySelector('.product-selection__ctas');
            const tlSticky = gsap.timeline({ paused: true, ease: '' });
            tlSticky.set(ref, {
                y: 0,
            });
            tlSticky.to(ref, {
                y: '100%',
            });
            const hasDetails = document.getElementById('pdp-details-out');
            // ANCHOR - STICKY - MOBILE INIT --------------------------------------------------------------------
            if (!isDesktop && ctas) {
                ScrollTrigger.create({
                    id: 'pdp-sticky-mobile',
                    markers: markers,
                    trigger: ctas,
                    start: 'top bottom',
                    end: 'top 80%',
                    scrub: true,
                    onUpdate: ({ progress }) => tlSticky.progress(progress),
                });
            }
            if (hasDetails) {
                // ANCHOR - STICKY IN --------------------------------------------------------------------
                ScrollTrigger.create({
                    id: 'pdp-sticky-in',
                    trigger: '#pdp-details-in',
                    start: 'top 20%',
                    end: 'top top',
                    scrub: true,
                    markers: !!markers && {
                        indent: 400,
                    },
                    onUpdate: ({ progress }) => tlSticky.progress(isDesktop ? progress : negativeMapper(progress)),
                    onEnter: () => {
                        customEventBus.emit('header:setpdp', { isPdp: false });
                    },
                    onLeaveBack: () => {
                        customEventBus.emit('header:setpdp', { isPdp: true });
                    },
                });
                // ANCHOR - STICKY OUT --------------------------------------------------------------------
                ScrollTrigger.create({
                    id: 'pdp-sticky-out',
                    trigger: '#pdp-details-out',
                    start: () => 'top 20%',
                    end: () => 'top top',
                    scrub: true,
                    markers: !!markers && {
                        indent: 100,
                    },
                    onUpdate: ({ progress }) => tlSticky.progress(isDesktop ? negativeMapper(progress) : progress),
                });
            }
            else {
                // ANCHOR - HEADER REACTIVATE --------------------------------------------------------------------
                //if details is not present
                ScrollTrigger.create({
                    id: 'pdp-header-in',
                    trigger: '#product-content',
                    start: () => `top +=${headerHeight}`,
                    end: 'top top',
                    markers: !!markers && {
                        indent: 400,
                    },
                    onEnter: () => {
                        customEventBus.emit('header:setpdp', { isPdp: false });
                    },
                    onLeaveBack: () => {
                        customEventBus.emit('header:setpdp', { isPdp: true });
                    },
                });
            }
        }
    };
    // !SECTION - END GSAP
    return setRef;
};
export default useStickybarAnimation;
